export class ResetPasswordArgs {
  public emailAddress: string;
}
